import { useTranslation } from "react-i18next";

export const useCurrencyText = (amount: string, currencyDisplay="name") => {
    const [_, i18next] = useTranslation();

    const currencyFormatOptions: Intl.NumberFormatOptions = { style: 'currency', currency: 'SAR', currencyDisplay: currencyDisplay};
    const currencyFormatter = new Intl.NumberFormat(i18next.language, currencyFormatOptions);
    return currencyFormatter.format(Number(amount?.replaceAll(',','') ?? '0'));
}